import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withKeys as _withKeys, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "operators" }
const _hoisted_2 = { class: "app-wrapper" }
const _hoisted_3 = { class: "section-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_5 = { class: "first-column-with-icon-type" }
const _hoisted_6 = { class: "name-type-block" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "emq-table-footer" }

import { getProfitsharingPayeeList, getProfitSharingReport } from '@/api/operation'
import { SEARCH_FORM_RES_PROPS as colProps } from '@/common/constants'
import { dateFormat } from '@/common/tools'
import PreWithEllipsis from '@/components/PreWithEllipsis.vue'
import CommonPagination from '@/components/commonPagination.vue'
import useI18nTl from '@/hooks/useI18nTl'
import usePaginationRemember from '@/hooks/usePaginationRemember'
import usePaginationWithHasNext from '@/hooks/usePaginationWithHasNext'
import { Refresh, RefreshLeft, Search, Plus, ArrowUp, ArrowDown } from '@element-plus/icons-vue'
import { pick } from 'lodash'
import PayeeUpsert from './components/PayeeUpsert.vue'
import WithdrawsApply from './components/WithdrawsApply.vue'
import BindUser from './components/BindUser.vue'
import { Ref } from 'vue'
import SelectOperator from '@/components/SelectOperator.vue'
import PermissionLink from '@/components/PermissionLink.vue'
import LinkOperator from '@/components/Links/LinkOperator.vue'
import ProfitBillView from './components/ProfitBillView.vue'
import LinkUser from '@/components/Links/LinkUser.vue'


import { defineComponent, ref } from 'vue'

const __default__ = defineComponent({
  name: 'Payees',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const profitBillViewRef = ref(null)
const { t } = useI18nTl('Evses')

const showApplyWithdrawDialog = ref(false)
const showDialog = ref(false)
const showMoreQuery = ref(false)
const showIsEdit = ref(false)
const showInfo: Ref<undefined | Record<string, any>> = ref(undefined)
const tableData = ref([])
const lockTable = ref(false)
const TableCom = ref()
const params = ref({})
const fuzzyParams = ref<Record<string, any>>({})
const { pageMeta, pageParams, initPageMeta, setPageMeta, toPageMeta } = usePaginationWithHasNext()
const { updateParams } = usePaginationRemember('operators-detail')

const applyWithdraw = (info: any) => {
  showApplyWithdrawDialog.value = true
  showInfo.value = info
}

const addInfo = () => {
  showDialog.value = true
  showInfo.value = undefined
  showIsEdit.value = false
}

const editInfo = (info: any) => {
  showDialog.value = true
  showInfo.value = info
  showIsEdit.value = true
}

const bindUserDialog = ref(false)
const bindUserWalletInfo = ref({
  walletId: '0',
  operatorId: '0',
})

const bindUser = (info: any) => {
  bindUserDialog.value = true
  bindUserWalletInfo.value.walletId = info.wallet.id
  bindUserWalletInfo.value.operatorId = info.wallet.operatorId
}

const showBillDialog = ref(false)
const showBillInfo = ref(null)

const showBill = (info: any) => {
  showBillInfo.value = info
  showBillDialog.value = true
  // 调用 ProfitBillView 组件的 open 方法
  if (info && info.payee && info.payee.payeeId) {
    profitBillViewRef.value?.open(info.payee.payeeId)
  }
}

const handleSearch = async () => {
  params.value = genQueryParams(fuzzyParams.value)
  console.log('params', params.value)
  loadTableData({ page: 1 })
}

const handleReset = () => {
  fuzzyParams.value = {}
  handleSearch()
}

const genQueryParams = (params: Record<string, any>) => {
  let newParams: Record<string, any> = {}
  const { payeeId, payeeName, operatorId } = params
  newParams = {
    payeeId: payeeId || undefined,
    payeeName: payeeName || undefined,
    operatorId: operatorId || undefined,
  }
  return newParams
}

const loadTableData = async (_params = {}) => {
  lockTable.value = true
  const sendParams = {
    ...params.value,
    pageReq: {
      ...pageParams.value,
      ..._params,
    },
  }

  try {
    const { list = [], pageReply = {} } = await getProfitsharingPayeeList(sendParams)
    const meta = toPageMeta(sendParams.pageReq, pageReply)
    tableData.value = list
    setPageMeta(meta)
    updateParams({ ...pick(meta, ['limit', 'page']), ...params.value })
  } catch (error) {
    tableData.value = []
    initPageMeta()
  } finally {
    lockTable.value = false
  }
}

loadTableData()

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_role = _resolveDirective("role")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      class: "search-wrapper",
      onKeyup: _withKeys(handleSearch, ["enter"])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: fuzzyParams.value.payeeName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fuzzyParams.value.payeeName) = $event)),
                  placeholder: _ctx.$t('Base.name'),
                  clearable: "",
                  onClear: handleSearch
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
              default: _withCtx(() => [
                _createVNode(SelectOperator, {
                  modelValue: fuzzyParams.value.operatorId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fuzzyParams.value.operatorId) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 16),
            (showMoreQuery.value)
              ? (_openBlock(), _createBlock(_component_el_col, _normalizeProps(_mergeProps({ key: 0 }, _unref(colProps))), {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: fuzzyParams.value.payeeId,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((fuzzyParams.value.payeeId) = $event)),
                      placeholder: _ctx.$t('Base.id'),
                      clearable: "",
                      onClear: handleSearch
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 16))
              : _createCommentVNode("", true),
            _createVNode(_component_el_col, _mergeProps(_unref(colProps), { class: "col-oper" }), {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  plain: "",
                  icon: _unref(Search),
                  onClick: handleSearch
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Base.search')), 1)
                  ]),
                  _: 1
                }, 8, ["icon"]),
                _createVNode(_component_el_button, {
                  icon: _unref(RefreshLeft),
                  onClick: handleReset
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Base.reset')), 1)
                  ]),
                  _: 1
                }, 8, ["icon"]),
                _createVNode(_component_el_tooltip, {
                  content: !showMoreQuery.value ? _ctx.$t('Base.showMore') : _ctx.$t('Base.lessMore'),
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      class: "icon-button",
                      plain: "",
                      icon: showMoreQuery.value ? _unref(ArrowUp) : _unref(ArrowDown),
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (showMoreQuery.value = !showMoreQuery.value))
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }, 8, ["content"])
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onKeyup"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          icon: _unref(Plus),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (addInfo()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.create')), 1)
          ]),
          _: 1
        }, 8, ["icon"])), [
          [_directive_role, 'payeeAdd']
        ]),
        _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          icon: _unref(Refresh),
          onClick: loadTableData
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.refresh')), 1)
          ]),
          _: 1
        }, 8, ["icon"])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        ref_key: "TableCom",
        ref: TableCom,
        "row-key": "id"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "name",
            "min-width": "80",
            label: _ctx.$t('Base.name'),
            align: "center"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_tooltip, {
                content: row.payee.payeeId,
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createVNode(PreWithEllipsis, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(row.payee.payeeName), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["content"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "payee.operatorName",
            "min-width": "80",
            label: _ctx.$t('Operation.operator')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(LinkOperator, {
                    id: row.payee.evseOperatorId,
                    name: row.payee.evseOperatorName
                  }, null, 8, ["id", "name"]),
                  _hoisted_7,
                  _createVNode(LinkOperator, {
                    id: row.payee.operatorId,
                    name: row.payee.operatorName
                  }, null, 8, ["id", "name"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "payee.bankCardName",
            "min-width": "80",
            label: _ctx.$t('Operation.bankCardName')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "payee.bankCard",
            "min-width": "80",
            label: _ctx.$t('Operation.bankCard')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "wallet.balance",
            "min-width": "80",
            label: _ctx.$t('Base.balance')
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(row.wallet.balance), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "wallet.userId",
            "min-width": "80",
            label: _ctx.$t('Operation.user')
          }, {
            default: _withCtx(({ row }) => [
              (row.wallet.userId != '0')
                ? (_openBlock(), _createBlock(LinkUser, {
                    key: 0,
                    id: row.wallet.userId,
                    name: row.wallet.userName
                  }, null, 8, ["id", "name"]))
                : (_openBlock(), _createElementBlock("span", _hoisted_8, "-"))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "wallet.createdAt",
            "min-width": "100",
            label: _ctx.$t('Base.createdAt')
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(_unref(dateFormat)(Number(row.wallet.createdAt) * 1000)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('Base.operation'),
            "class-name": "table-operation"
          }, {
            default: _withCtx(({ row }) => [
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                size: "small",
                plain: "",
                onClick: ($event: any) => (editInfo(row.payee))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.edit')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_role, 'payeeUpsert']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                size: "small",
                plain: "",
                onClick: ($event: any) => (applyWithdraw(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Order.withdraw')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_role, 'withdrawApply']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                size: "small",
                plain: "",
                onClick: ($event: any) => (bindUser(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Operation.bindUser')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_role, 'profitsharingWalletBind']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                size: "small",
                plain: "",
                onClick: ($event: any) => (showBill(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Operation.bill')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_role, 'profitsharingReport']
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [
          _directive_loading,
          lockTable.value,
          void 0,
          { lock: true }
        ]
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(CommonPagination, {
          metaData: _unref(pageMeta),
          "onUpdate:metaData": _cache[5] || (_cache[5] = ($event: any) => (_isRef(pageMeta) ? (pageMeta).value = $event : null)),
          onLoadPage: loadTableData
        }, null, 8, ["metaData"])
      ]),
      _createVNode(PayeeUpsert, {
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((showDialog).value = $event)),
        info: showInfo.value,
        isEdit: showIsEdit.value,
        onSubmitted: loadTableData
      }, null, 8, ["modelValue", "info", "isEdit"]),
      _createVNode(WithdrawsApply, {
        modelValue: showApplyWithdrawDialog.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((showApplyWithdrawDialog).value = $event)),
        info: showInfo.value
      }, null, 8, ["modelValue", "info"]),
      _createVNode(ProfitBillView, {
        modelValue: showBillDialog.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((showBillDialog).value = $event)),
        info: showBillInfo.value,
        ref_key: "profitBillViewRef",
        ref: profitBillViewRef
      }, null, 8, ["modelValue", "info"]),
      _createVNode(BindUser, {
        modelValue: bindUserDialog.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((bindUserDialog).value = $event)),
        walletId: bindUserWalletInfo.value.walletId,
        operatorId: bindUserWalletInfo.value.operatorId
      }, null, 8, ["modelValue", "walletId", "operatorId"])
    ])
  ]))
}
}

})